import React, { useState, useEffect } from "react";
// import '../../styles/MainDishes.css';
import '../../styles/MenuItems.css';
import '../../styles/Styles.css';

function Pizzas() {

    const [pizzas, setPizzas] = useState([]);

    useEffect(() => {
        fetch('https://strapi.restauracjasamiswoi.pl/api/categories?populate=menu_items&pagination[pageSize]=30')
        .then(response => response.json())
        .then((data) => {
            const categoryPizzas = data.data.find(item => item.name === 'PIZZA');

            if (categoryPizzas) {
                setPizzas(categoryPizzas.menu_items);
            }
        })

    }, []);

    return (
        <div className="container-fluid section-green-background">
            <div className="container section-menu-item">
                <div className="dish-photo-container-20">
                    <img src={require("../../assets/menu/pizza.webp")} className="dish-photo-main-dishes img-menu img-rounded shadow" />
                </div>
                <div className="menu-right-75">
        <p className="menu-item-title-font fs-1 fw-bold item-title">PIZZA</p>
        <hr/>
        {pizzas.map((pizza) => (
            <div key={pizza.id} className="container">
                <div className="dish-name-container d-flex justify-content-between">
                    <p className="menu-item-title-font fs-5 m-0">{pizza.name}</p>
                    <p className="fs-5 m-0">{pizza.price}zł</p>
                </div>
                <p className="ingridients-container fs-6 m-0 fw-lighter">{pizza.ingredients}</p>
                <div className="mb-4 mt-4 divide-line divide-line-white"/>
            </div>
        ))}
        </div>
        </div>
        </div>

    )
}

export default Pizzas;